import { useState } from 'react';
import { Typography } from 'antd';
import useTranslation from '@/hooks/useTranslation';

export function ExpandableText({ children ,text, rows = 2, style = {}, ellipsis = {}, ...rest }) {
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();
    const baseFontSize = Number(style?.fontSize) || 14;
    const toggleFontSize = Math.max(10, baseFontSize - 2);

    if (!text && !children) return null;

    return (
        <Typography.Paragraph
            ellipsis={{
                rows,
                expandable: "collapsible",
                expanded,
                symbol: (
                    <span style={{ fontSize: toggleFontSize }}>
                        {expanded ? ` ${t('expandable.show_less')}` : ` ${t('expandable.read_more')}`}
                    </span>
                ),
                onExpand: (_, info) => setExpanded(info?.expanded ?? !expanded),
                ...ellipsis,
            }}
            style={{ marginBottom: 0, ...style }}
            {...rest}
        >
            {text || children}
        </Typography.Paragraph>
    );
}
export default ExpandableText;
